import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getConsent } from './CookieConsent';

const AnalyticsRouteTracker = () => {
    const location = useLocation();

    useEffect(() => {
        if (getConsent() !== 'accepted') return;
        if (typeof window.gtag !== 'function') return;

        window.gtag('config', 'G-H4GRQ01GG0', {
            page_path: location.pathname + location.search,
            page_location: window.location.href
        });
    }, [location.pathname, location.search]);

    // Track custom events — no-op if GA4 not loaded
    const trackEvent = (eventName, eventData = {}) => {
        if (getConsent() !== 'accepted') return;
        if (typeof window.gtag === 'function') {
            window.gtag('event', eventName, eventData);
        }
    };

    window.trackAnalytics = trackEvent;

    return null;
};

export default AnalyticsRouteTracker;
